const pjson = require('../../package.json');

export const environment = {
    production: true,
    version: pjson.version,
    server: {
        protocol: 'https',
        host: 'api.tuti.education',
        port: 443,
        apiPath: 'api/'
    },
    websocket: {
        host: 'api.tuti.education',
        port: 443
    },
    appTitle: "Tutì Video",
    configuration: <any>{},
    swarmifyLoaded: false,
    webDeviceUUID: "",
    gtag: {
        enabled: false,
        gtmIframeID: "GTM-XXXXXXX",
        config1: "G-XXXXXXXXXX",
        config2: "G-YYYYYYYYYY"
    },
    iuBenda: {
        enabled: false,
        script1: {
            text: ``
        },
        script2: {
            src: ``
        }
    }
};